import * as moment from 'moment';
import { Component, OnInit, OnDestroy } from '@angular/core';
import 'rxjs/add/operator/takeUntil';
import {
  UserNotificationAction,
  UserNotificationActionType,
  UserNotificationOptions,
  NotificationService,
} from './notification.service';
import { Subject } from 'rxjs/Subject';
import { Router } from '@angular/router';
import { ChallengeService } from 'app/shared/services/challenge.service';
import { MatSnackBar } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-user-notification',
  templateUrl: './user-notification.component.html',
  styleUrls: ['./user-notification.component.scss'],
})
export class UserNotificationComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  snackbarDisplayState = 'hidden';

  private timeout: any;

  snackbarOptions: UserNotificationOptions = {
    message: '',
    visible: false,
    duration: -1,
    dismissible: false,
    color: '#000000',
    buttons: [],
  };

  constructor(
    private notificationService: NotificationService,
    private challengeService: ChallengeService,
    private router: Router,
    private snackBar: MatSnackBar,
    private translate: TranslateService
  ) {}

  public ngOnInit(): void {
    this.notificationService.notificationOptionsObservable.takeUntil(this.ngUnsubscribe).subscribe((value) => {
      if (value.visible) {
        if (this.snackbarOptions.visible) {
          this.snackbarDisplayState = 'hidden';
          clearTimeout(this.timeout);
          setTimeout(() => {
            this.snackbarDisplayState = 'shown';
          }, 250);
        } else {
          this.snackbarDisplayState = 'shown';
        }

        this.snackbarOptions = value;

        if (this.snackbarOptions.duration > 0) {
          this.timeout = setTimeout(() => {
            this.notificationService.dismiss();
          }, this.snackbarOptions.duration);
        }
      } else {
        this.snackbarDisplayState = 'hidden';
      }
    });
  }

  public buttonClicked(action: UserNotificationAction): void {
    if (!action) {
      return;
    }
    switch (action.type) {
      case UserNotificationActionType.ACCEPT_APPLICATION: {
        this.challengeService.displayedChallenge.take(1).subscribe((challenge) => {
          if (challenge && (challenge._id !== action.challengeID || moment(challenge.start).isBefore(moment()))) {
            this.translate.get('CHALLENGE.error.preparationPhaseOver').subscribe((text) => {
              this.snackBar.open(text, null, {
                verticalPosition: 'top',
                duration: 8000,
                panelClass: ['b2a-error', 'top'],
              });
            });
          } else {
            this.challengeService.acceptApplication(action.challengeID, action.teamID, action.userID).catch((error) => {
              const errorObject = error.body.error.error;

              if (errorObject.startsWith('maximum_challenge_members')){
                this.translate.get('CHALLENGE.error.maximumChallengeMemberReached').subscribe((text) => {
                  this.snackBar.open(text, null, {
                    verticalPosition: 'top',
                    duration: 4000,
                    panelClass: ['b2a-error', 'top'],
                  });
                });
              }
            });
            this.dismiss();
          }
        });
        break;
      }
      case UserNotificationActionType.REJECT_APPLICATION: {
        this.challengeService.displayedChallenge.take(1).subscribe((challenge) => {
          if (challenge && (challenge._id !== action.challengeID || moment(challenge.start).isBefore(moment()))) {
            this.translate.get('CHALLENGE.error.preparationPhaseOver').subscribe((text) => {
              this.snackBar.open(text, null, {
                verticalPosition: 'top',
                duration: 8000,
                panelClass: ['b2a-error', 'top'],
              });
            });
          } else {
            this.challengeService.cancelApplication(action.challengeID, action.teamID, action.userID);
            this.dismiss();
          }
        });
        break;
      }
      case UserNotificationActionType.MANAGE_TEAM: {
        this.router.navigate(['stats']).then();
        break;
      }
      case UserNotificationActionType.SELECT_TEAM: {
        this.challengeService.displayedChallenge.take(1).subscribe((challenge) => {
          if (challenge && (challenge._id !== action.challengeID || moment(challenge.start).isBefore(moment()))) {
            this.translate.get('CHALLENGE.error.preparationPhaseOver').subscribe((text) => {
              this.snackBar.open(text, null, {
                verticalPosition: 'top',
                duration: 8000,
                panelClass: ['b2a-error', 'top'],
              });
            });
          } else {
            this.router.navigate(['challenge', action.challengeID, 'team']).then();
          }
        });
        break;
      }
      default: {
        break;
      }
    }
  }

  public dismiss(): void {
    clearTimeout(this.timeout);
    this.notificationService.dismiss();
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/user-notification/user-notification.component.ts